<template>
  <v-container>
    <v-text-field v-model="motd" label="Bericht"></v-text-field>
    <v-checkbox
      v-model="attachStockList"
      label="Stocklijst toevoegen aan print"
    ></v-checkbox>
    <v-btn @click="updateMotd" :loading="loading.saving" class="mb-4"
      >Opslaan</v-btn
    >
    <v-divider></v-divider>
    <v-btn color="info" class="white--text mt-4" @click="signout"
      >Afmelden</v-btn
    >
    <v-snackbar v-model="saved" color="success">Opgeslagen</v-snackbar>
  </v-container>
</template>

<script>
import { auth, firestore } from "firebase";
export default {
  data() {
    return {
      saved: false,
      motd: "",
      attachStockList: true,
      loading: {
        saving: false,
      },
    };
  },
  mounted() {
    this.fetchSettings();
  },
  methods: {
    signout() {
      auth().signOut();
      this.$router.push("/login");
    },
    async updateMotd() {
      this.loading.saving = true;
      await firestore().collection("App-Settings").doc("Orders").set({
        motd: this.motd,
        attachStockList: this.attachStockList,
      });
      this.loading.saving = false;
      this.saved = true;
    },
    async fetchSettings() {
      let s = await firestore().collection("App-Settings").doc("Orders").get();
      this.motd = s.data().motd;
      this.attachStockList = s.data().attachStockList;
    },
  },
};
</script>

<style>
</style>